import { createFileRoute } from '@tanstack/react-router';
import { BroadcastsListRouteView } from '@/pages/workspaces/broadcasts/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The Broadcasts frame — header, search, tab bar and pagination — around whichever tab is
 * showing. No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from.
 */
function BroadcastsRoute() {
  return (
    <LastWorkspaceResolver>
      <BroadcastsListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts')({
  component: BroadcastsRoute,
});
